/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equipment_Group_AccessoriesInputs */

const en_us2_equipment_group_accessories = /** @type {(inputs: Equipment_Group_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessories`)
};

const pt_br2_equipment_group_accessories = /** @type {(inputs: Equipment_Group_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acessórios`)
};

const es_419_equipment_group_accessories = /** @type {(inputs: Equipment_Group_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesorios`)
};

const pt_pt2_equipment_group_accessories = /** @type {(inputs: Equipment_Group_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acessórios`)
};

const fr_fr2_equipment_group_accessories = /** @type {(inputs: Equipment_Group_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessoires`)
};

const de_de2_equipment_group_accessories = /** @type {(inputs: Equipment_Group_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zubehör`)
};

const it_it2_equipment_group_accessories = /** @type {(inputs: Equipment_Group_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessori`)
};

/**
* | output |
* | --- |
* | "Accessories" |
*
* @param {Equipment_Group_AccessoriesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equipment_group_accessories = /** @type {((inputs?: Equipment_Group_AccessoriesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equipment_Group_AccessoriesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equipment_group_accessories(inputs)
	if (locale === "es-419") return es_419_equipment_group_accessories(inputs)
	if (locale === "pt-PT") return pt_pt2_equipment_group_accessories(inputs)
	if (locale === "fr-FR") return fr_fr2_equipment_group_accessories(inputs)
	if (locale === "de-DE") return de_de2_equipment_group_accessories(inputs)
	if (locale === "it-IT") return it_it2_equipment_group_accessories(inputs)
	return en_us2_equipment_group_accessories(inputs)
});
export { equipment_group_accessories as "equipment.group.accessories" }